import createIcon from '../../createIcon';

/**
 * @component @name Lan
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgMjJIMjFWMTVIMThWMTFIMTNWOUgxNlYySDhWOUgxMVYxMUg2VjE1SDNWMjJIMTFWMTVIOFYxM0gxNlYxNUgxM1YyMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Lan = createIcon('Lan', [
  [
    'path',
    {
      d: 'M13 22H21V15H18V11H13V9H16V2H8V9H11V11H6V15H3V22H11V15H8V13H16V15H13V22Z',
      key: '1bui75',
    },
  ],
]);

export default Lan;
